import { takeEvery, put, call, select, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_CMG_STATUS_REQUEST,
  GET_CMG_STATUS_SUCCESS,
  GET_CMG_STATUS_FAILURE,
  GET_CMG_STATUS_LOADING,
} = therapyPlanningAction;

// One request per therapy week on screen, so the response is filed under the week it was asked
// for rather than overwriting whatever arrived last.
function* getCmgStatus(action: any): SagaReturnType<any> {
  const weekKey = action?.payload?.weekKey;
  try {
    yield put({ type: GET_CMG_STATUS_LOADING, payload: { weekKey } });
    const response = yield call(therapyPlanningService.getCmgStatus, action?.payload);
    if (response?.status === 200) {
      // Guard: discard stale responses if the patient changed since the request was made
      const currentPatientUuid: string = yield select(
        (state: any) => state?.selectPatientReducer?.patientInfo?.uuid
      );
      if (action?.payload?.patientId && action?.payload?.patientId !== currentPatientUuid) {
        return;
      }
      yield put({
        type: GET_CMG_STATUS_SUCCESS,
        payload: { weekKey, data: response?.data?.data },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_CMG_STATUS_FAILURE, payload: { weekKey, error } });
  }
}

function* getCmgStatusSaga() {
  yield takeEvery(GET_CMG_STATUS_REQUEST, getCmgStatus);
}

export default getCmgStatusSaga;
